import {
    request,
    headers
} from './request.js'


/**
 * 登陆
 * @param {*} admin
 * @returns
 */
export function postLogin(admin) {
    return request({
        url: '/user/login',
        method: 'post',
        headers,
        data: admin
    })
}

// 推出登陆
export function getOutAdmin() {
    return request({
        url: '/user/logout',
    })
}

// 请求权限表
export function getRoutesData(roleCode) {
    return request({
        url: `/api/infrastructure/model/getRoutesData?roleCode=${roleCode}`
    })
}

/**
 * 请求个人信息
 */
export function postUserInfo(admin) {
    return request({
        url: '/user/getUserInfo',
        method: 'post',
    })
}

/**
 * 修改密码
 */
export function postModifyPassword(userId, password) {
    return request({
        url: '/user/updatePassword',
        method: 'post',
        data: {
            userId,
            password
        }
    })
}

/**
 * 未读消息
 */
export function postNewInfo() {
    return request({
        url: '/api/infrastructure/task/unreadTask',
        method: 'post'
    })
}


/**
 * 查询登录日志
 * */
export function getLoginLogList(current,size){
    return request({
        url: `/user/getUserLoginLogList?current=${current}&size=${size}`,
        method: 'POST'
    })
}



// WEBPACK FOOTER //
// ./src/network/login.js